import React from "react"
import {Route, Switch} from "react-router-dom"
import * as Util from "../common"
import BetaKeyApplyView from "./BetaKeyApplyView"
import BetaKeyCreateView from "./BetaKeyCreateView"

export default function BetaRouter(props) {
  const {match} = props
  return (
    <Switch>
      <Route path={match.path + "/create"} component={BetaKeyCreateView} />
      <Route
        path={match.path + "/join/:betaKey"}
        component={BetaKeyApplyView}
      />
      <Route component={Util.NotFoundView} />
    </Switch>
  )
}



// WEBPACK FOOTER //
// ./src/beta/BetaRouter.js